/* eslint-disable import/order */
/* eslint-disable no-unused-vars */
import Button from "components/Button";
import Divider from "components/Divider";
import H1 from "components/H1";
import H4 from "components/H4";
import TextInput from "components/TextInput";
import Toast from "components/Toast";
import React, { useState, useEffect } from "react";
import Wrapper from "./Wrapper";
import { useHistory } from "react-router-dom";
import authSvc from "services/authSvc";
import userSvc from "services/userSvc";
import organizationSvc from "services/organizationSvc";

const EditOrganizationPage = () => {
  const history = useHistory();
  const [businessUnitName, setBusinessUnitName] = useState("");
  const [businessPhone, setBusinessPhone] = useState("");
  const [businessAddress, setBusinessAddress] = useState("");
  const [bussinessWebsiteAddress, setBusinessWebsiteAddress] = useState("");

  const [loading, setLoading] = useState(false);
  const initialError = {
    businessUnitName: "",
    businessPhone: "",
    businessAddress: "",
    bussinessWebsiteAddress: ``,
  };
  const [error, setError] = useState(initialError);
  const [toastData, setToastData] = useState({});
  const [toastVisible, setToastVisible] = useState(false);
  const [currentUser, setCurrentUser] = useState();

  useEffect(() => {
    (async () => {
      const currUser = authSvc.currentUser();
      const userData = await userSvc.get(currUser?.user?.id);
      if (!userData?.data?.data?.organization) {
        history.push(`/company-data-first`);
      } else {
        setCurrentUser(userData.data.data);
        const orgData = await organizationSvc.getById(userData.data.data.organization);
        console.log('orgData', orgData)
        if (orgData?.data.data) {
          setBusinessUnitName(orgData.data.data.businessName);
          setBusinessPhone(orgData.data.data.businessPhone);
          setBusinessAddress(orgData.data.data.businessAddress);

          if(orgData.data.data.websiteUrl){
            setBusinessWebsiteAddress(orgData.data.data.websiteUrl.replace("https://", ""));
          }
        }
      }
    })();
  }, []);

  const validation = () => {
    return true;
  };

  const onEditOrganization = async () => {
    setLoading(true);
    const isValidate = validation();
    if (!isValidate) {
      setLoading(false);
      return;
    }

    const data = {
      business_name: businessUnitName,
      business_phone: businessPhone,
      business_address: businessAddress,
      website_url: `https://${bussinessWebsiteAddress}`,
    };
    try {
      setError("");
      await organizationSvc.update(currentUser.organization, data);
      setToastData({ description: "Your organization data has been successfully updated" });
      setToastVisible(true);
      setLoading(false);
    } catch (err) {
      setError(err);
      setLoading(false);
    }
  };

  return (
    <Wrapper className="d-flex flex-column">
      <H1 className="margin-bottom-15">Edit Organization</H1>
      <H4>
        Let’s get started! Before you start create an application, you can filll the company data
        first.
      </H4>
      <Divider style={{ marginBlock: 30 }} />
      <TextInput
        title="Name of business unit"
        value={businessUnitName}
        placeholder=""
        className="margin-bottom-5"
        onChange={(event) => setBusinessUnitName(event.target.value)}
        invalidFeedback={error.password}
      />
      <TextInput
        title="No. business phone"
        value={businessPhone}
        placeholder=""
        className="margin-bottom-5"
        onChange={(event) => setBusinessPhone(event.target.value)}
        invalidFeedback={error.password}
      />
      <TextInput
        title="Business address"
        value={businessAddress}
        placeholder=""
        className="margin-bottom-5"
        onChange={(event) => setBusinessAddress(event.target.value)}
        invalidFeedback={error.password}
      />
      <TextInput
        title="Website address"
        value={bussinessWebsiteAddress}
        placeholder=""
        className="margin-bottom-5"
        prepend="https://"
        onChange={(event) => setBusinessWebsiteAddress(event.target.value)}
        invalidFeedback={error.password}
      />

      <div>
        <Button loading={loading} handleRoute={() => onEditOrganization()} primary>
          Save Changes
        </Button>
      </div>
      <Toast
        setIsVisible={(val) => setToastVisible(val)}
        isVisible={toastVisible}
        description={toastData.description}
        undo={toastData.undo}
      />
    </Wrapper>
  );
};

export default EditOrganizationPage;
